(function () {
  'use strict';

  // El <script src=perso-wizard.js> vive DENTRO de snippets/perso-wizard.liquid, así que el
  // re-render de la seccion de Prestige al cambiar de variante RE-INYECTA y RE-EJECUTA este
  // modulo → un 2º boot() creaba una closure y un overlay duplicados (dos openWizard que se
  // podaban el overlay mutuamente y dejaban el wizard sin abrir). Guard global: la re-ejecucion
  // es un no-op; sobrevive el primer boot. La copia de overlay que deja el re-render se poda
  // en openWizard/al cambiar variante.
  if (window.__persoWizardLoaded) return;
  window.__persoWizardLoaded = true;

  // Mount generico: EN VIVO (PW_LIVE) o preview (?pw=1). LUMEA en preview hasta confirmar
  // los property names de Teeinblue con un pedido real.
  var PW_LIVE = [
    // MIGRACIÓN TOTAL (21 jul 2026): todos los personalizables — QA preview 78/78 contra contratos Textify byte-exactos
    'collar-nombre-personalizado',
    'collar-nombre-personalizable',
    'pulsera-uniones-personalizado',
    'collar-amity-personalizado',
    'pulsera-secreta-personalizado',
    'collar-affection-personalizado',
    'collar-apego-personalizado',
    'collar-celeste-personalizado',
    'collar-infinito-personalizado',
    'collar-interestelar-personalizado',
    'collar-nacimiento-personalizado-1',
    'collar-pacto-personalizado',
    'collar-pasion-personalizado',
    'collar-placa-personalizado',
    'collar-promesa-personalizado',
    'collar-puzzle-personalizado',
    'collar-recuerdos-personalizado',
    'collar-romantica-personalizado',
    'collar-sensacion-personalizado',
    'collar-sentimiento-personalizado',
    'collar-siempre-personalizado',
    'grabado-personalizado',
    'pulsera-alianza-personalizado',
    'pulsera-apego-personalizado',
    'pulsera-coraje-personalizado',
    'pulsera-cordelia-personalizado',
    'pulsera-dua-personalizado',
    'pulsera-hombre-lord-personalizado',
    'pulsera-hombre-rebel-personalizado',
    'pulsera-infinito-personalizado',
    'pulsera-rosicler-personalizado',
    'pulsera-sensacion-personalizable',
    // Lote 28 jul 2026 — resto de personalizables
    'collar-coraje-personalizado', 'collar-ventura-personalizado', 'collar-musa-personalizado', 'collar-five-star-personalizable', 'collar-alianza-personalizado', 'collar-medallon-personalizado',
    // Lote 1 sep 2026 — altas del catalogo posteriores a la migracion. La identidad (CB187) se
    // republico el 28-ago y se quedo SIN forma de capturar el grabado; las otras tres siguen en
    // borrador aqui, se registran ya para que publicarlas no repita el fallo.
    'pulsera-de-identidad-personalizado', 'pulsera-barra-eterna-personalizado', 'pulsera-no-me-olvides-mujer-personalizado', 'pulsera-no-me-olvides-hombre-personalizado'
  ]; // bespoke (ATC oculto por CSS) — DEBEN estar aqui o el guard deja la PDP sin boton de compra
  try {
    var _pwActive = false;
    var _pw = new URLSearchParams(location.search).get('pw');
    if (_pw === '1') sessionStorage.setItem('pw_preview', '1');
    if (_pw === '0') sessionStorage.removeItem('pw_preview');
    if (sessionStorage.getItem('pw_preview') === '1') _pwActive = true;
    var _cfgEl = document.querySelector('[data-pw-config]');
    if (_cfgEl) { try { if (PW_LIVE.indexOf(JSON.parse(_cfgEl.textContent).handle) > -1) _pwActive = true; } catch (e) {} }
    if (_pwActive) document.documentElement.classList.add('pw-preview');
  } catch (e) {}
  try {
    if (document.documentElement.classList.contains('pw-preview')) {
      var _killTB = function () {
        document.querySelectorAll('[data-tb-clone-atc]').forEach(function (el) { el.style.display = 'none'; });
        document.querySelectorAll('[data-tb-app-fields]').forEach(function (f) {
          var blk = f.closest('.product-info__block-item') || f.closest('.shopify-block') || f.parentElement;
          // Si en ese bloque vive el boton del wizard, ocultar SOLO los campos de Textify: cuando
          // los inyecta dentro del bloque de buy_buttons, ocultar el bloque entero se llevaba
          // por delante el boton PERSONALIZALO y el ATC (reporte Olymar, amity en SOPH).
          if (blk && !blk.querySelector('[data-pw-open]')) blk.style.display = 'none';
          else f.style.display = 'none';
        });
      };
      _killTB();
      new MutationObserver(_killTB).observe(document.documentElement, { childList: true, subtree: true });
    }
  } catch (e) {}

  var LANG = ((document.documentElement.lang || 'en') + '').slice(0, 2).toLowerCase();
  var I18N = {
    en: {
      refreshCart: "Refresh cart",
      addedRefreshError: "Your item was added. We could not refresh the cart. Retry to update the cart without adding it again.",
      open: "PERSONALISE IT",
      soldOut: "Sold out",
      adding: "Adding…",
      context: "Write the text for this piece. You can review it before adding to cart.",
      cutContext: "Your text is cut into the metal. Write it exactly as you want it to appear.",
      reviewNote: "Check the text and selected option. Personalised items are excluded from standard returns and size exchanges.",
      smallRing: "Small ring",
      bigRing: "Large ring",
      smallHeart: "Small heart",
      bigHeart: "Large heart",
      roundStar: "Round pendant",
      littleStar: "Small star",
      firstPiece: "First piece",
      secondPiece: "Second piece",
      frontArea: "Front",
      backArea: "Back",
      side1: "Side 1",
      side2: "Side 2",

      optionalWord: 'optional', optPlaceholder: 'Leave empty to skip this area', notEngraved: 'not engraved', extraRow: 'Additional engraving × {n}',
      stepLabel: 'Personalisation', introTitle: 'Engrave your piece',
      introP1a: 'Your piece has <b>{n} {units}</b> to engrave. Each {unit} is engraved on the <b>front</b>',
      introP1addon: ' and, if you like, on the <b>back</b> too (+{price})', introP1end: '.',
      introP2: "In the next steps you'll write the text for each one. At the end you'll see a <b>summary</b> before adding to cart.",
      start: 'Start', stepOf: 'Step {a} of {b}', yourEngraving: 'Your engraving',
      frontLabel: 'What do we engrave on the front?', placeholder: 'Type the text you want engraved',
      backToggle: 'Also engrave the back (+{price})', backLabel: 'What do we engrave on the back?',
      next: 'Next', review: 'Review', lastStep: 'Last step', reviewTitle: 'Review your engraving',
      frontWord: 'front', backWord: 'back', total: 'Total', totalPrefix: 'Total: ',
      addToCart: 'Add to cart', error: "We couldn't add it to the cart. Please try again.",
      nameFrontLabel: 'Which name do you want?', namePlaceholder: 'Type the name (e.g. Emma)',
      nameIntroTitle: 'Your name, made into a jewel', nameIntroP1: 'This piece is <b>laser-cut in one piece</b> with the name you choose — the name IS the jewel.', nameIntroP2: "Write it exactly as you want it — each piece is <b>handmade one by one</b>: no two are alike. You'll see a <b>summary</b> before adding to cart.", nameStepTitle: 'Your name', nameReviewTitle: 'Review the name', nameSumLabel: 'Name',
      units: { name: { one: 'name', many: 'names' }, tag: { one: 'tag', many: 'tags' }, ring: { one: 'ring', many: 'rings' } }
    },
    fr: {
      refreshCart: "Actualiser le panier",
      addedRefreshError: "Votre article a été ajouté. Impossible d’actualiser le panier. Réessayez pour actualiser sans ajouter l’article une seconde fois.",
      open: "PERSONNALISEZ-LE",
      soldOut: "Épuisé",
      adding: "Ajout…",
      context: "Écrivez le texte pour ce bijou. Vous pourrez le vérifier avant de l’ajouter au panier.",
      cutContext: "Votre texte est découpé dans le métal. Écrivez-le exactement comme vous souhaitez le voir.",
      reviewNote: "Vérifiez le texte et l’option choisie. Les articles personnalisés sont exclus des retours ordinaires et des échanges de taille.",
      smallRing: "Petit anneau",
      bigRing: "Grand anneau",
      smallHeart: "Petit cœur",
      bigHeart: "Grand cœur",
      roundStar: "Pendentif rond",
      littleStar: "Petite étoile",
      firstPiece: "Première pièce",
      secondPiece: "Deuxième pièce",
      frontArea: "Devant",
      backArea: "Dos",
      side1: "Côté 1",
      side2: "Côté 2",

      optionalWord: 'optionnel', optPlaceholder: 'Laissez vide pour ne pas graver cette zone', notEngraved: 'non gravé', extraRow: 'Gravure supplémentaire × {n}',
      stepLabel: 'Personnalisation', introTitle: 'Gravez votre bijou',
      introP1a: 'Votre bijou a <b>{n} {units}</b> à graver. Chaque {unit} se grave sur le <b>devant</b>',
      introP1addon: ' et, si vous voulez, aussi au <b>dos</b> (+{price})', introP1end: '.',
      introP2: 'Dans les étapes suivantes, vous écrirez le texte de chacune. À la fin, un <b>récapitulatif</b> avant l&#39;ajout au panier.',
      start: 'Commencer', stepOf: 'Étape {a} sur {b}', yourEngraving: 'Votre gravure',
      frontLabel: 'Que gravons-nous devant ?', placeholder: 'Écrivez le texte à graver',
      backToggle: 'Graver aussi le dos (+{price})', backLabel: 'Que gravons-nous derrière ?',
      next: 'Suivant', review: 'Vérifier', lastStep: 'Dernière étape', reviewTitle: 'Vérifiez votre gravure',
      frontWord: 'devant', backWord: 'dos', total: 'Total', totalPrefix: 'Total : ',
      addToCart: 'Ajouter au panier', error: "Impossible d'ajouter au panier. Réessayez.",
      nameFrontLabel: 'Quel prénom voulez-vous ?', namePlaceholder: 'Écrivez le prénom (ex. Emma)',
      nameIntroTitle: 'Votre prénom, devenu bijou', nameIntroP1: "Ce bijou est <b>découpé au laser d'une seule pièce</b> avec le prénom que vous choisissez — le prénom EST le bijou.", nameIntroP2: "Écrivez-le exactement comme vous le voulez : chaque pièce est <b>fabriquée à la main, une à une</b> — il n'y en a pas deux pareilles. Un <b>récapitulatif</b> s'affichera avant l'ajout au panier.", nameStepTitle: 'Votre prénom', nameReviewTitle: 'Vérifiez le prénom', nameSumLabel: 'Prénom',
      units: { name: { one: 'prénom', many: 'prénoms' }, tag: { one: 'plaquette', many: 'plaquettes' }, ring: { one: 'anneau', many: 'anneaux' } }
    },
    de: {
      refreshCart: "Warenkorb aktualisieren",
      addedRefreshError: "Dein Artikel wurde hinzugefügt. Der Warenkorb konnte nicht aktualisiert werden. Versuche es erneut, ohne den Artikel noch einmal hinzuzufügen.",
      open: "JETZT PERSONALISIEREN",
      soldOut: "Ausverkauft",
      adding: "Wird hinzugefügt…",
      context: "Schreibe den Text für dieses Schmuckstück. Du kannst ihn vor dem Hinzufügen zum Warenkorb prüfen.",
      cutContext: "Dein Text wird aus dem Metall ausgeschnitten. Schreibe ihn genau so, wie er erscheinen soll.",
      reviewNote: "Prüfe Text und Auswahl. Personalisierte Artikel sind von regulärer Rückgabe und Größenumtausch ausgeschlossen.",
      smallRing: "Kleiner Ring",
      bigRing: "Großer Ring",
      smallHeart: "Kleines Herz",
      bigHeart: "Großes Herz",
      roundStar: "Runder Anhänger",
      littleStar: "Kleiner Stern",
      firstPiece: "Erstes Stück",
      secondPiece: "Zweites Stück",
      frontArea: "Vorne",
      backArea: "Hinten",
      side1: "Seite 1",
      side2: "Seite 2",

      optionalWord: 'optional', optPlaceholder: 'Leer lassen, um diese Stelle nicht zu gravieren', notEngraved: 'nicht graviert', extraRow: 'Zusätzliche Gravur × {n}',
      stepLabel: 'Personalisierung', introTitle: 'Graviere dein Schmuckstück',
      introP1a: 'Dein Schmuckstück hat <b>{n} {units}</b> zum Gravieren. Jedes {unit} wird <b>vorne</b> graviert',
      introP1addon: ' und, wenn du magst, auch <b>hinten</b> (+{price})', introP1end: '.',
      introP2: 'In den nächsten Schritten schreibst du den Text für jedes. Am Ende siehst du eine <b>Übersicht</b>, bevor es in den Warenkorb geht.',
      start: 'Starten', stepOf: 'Schritt {a} von {b}', yourEngraving: 'Deine Gravur',
      frontLabel: 'Was gravieren wir vorne?', placeholder: 'Gib den Text ein, der graviert werden soll',
      backToggle: 'Auch die Rückseite gravieren (+{price})', backLabel: 'Was gravieren wir hinten?',
      next: 'Weiter', review: 'Prüfen', lastStep: 'Letzter Schritt', reviewTitle: 'Prüfe deine Gravur',
      frontWord: 'vorne', backWord: 'hinten', total: 'Gesamt', totalPrefix: 'Gesamt: ',
      addToCart: 'In den Warenkorb', error: 'Konnte nicht in den Warenkorb gelegt werden. Bitte versuche es erneut.',
      nameFrontLabel: 'Welcher Name soll es sein?', namePlaceholder: 'Gib den Namen ein (z. B. Emma)',
      nameIntroTitle: 'Dein Name, als Schmuckstück', nameIntroP1: 'Dieses Schmuckstück wird <b>aus einem Stück lasergeschnitten</b> — mit dem Namen, den du wählst. Der Name IST das Schmuckstück.', nameIntroP2: 'Schreib ihn genau so, wie du ihn willst — jedes Stück wird <b>von Hand, einzeln gefertigt</b>: keine zwei sind gleich. Vor dem Warenkorb siehst du eine <b>Übersicht</b>.', nameStepTitle: 'Dein Name', nameReviewTitle: 'Prüfe den Namen', nameSumLabel: 'Name',
      units: { name: { one: 'Name', many: 'Namen' }, tag: { one: 'Plättchen', many: 'Plättchen' }, ring: { one: 'Ring', many: 'Ringe' } }
    },
    it: {
      refreshCart: "Aggiorna il carrello",
      addedRefreshError: "Il tuo articolo è stato aggiunto. Impossibile aggiornare il carrello. Riprova per aggiornarlo senza aggiungere nuovamente l’articolo.",
      open: "PERSONALIZZALO",
      soldOut: "Esaurito",
      adding: "Aggiunta…",
      context: "Scrivi il testo per questo gioiello. Potrai verificarlo prima di aggiungerlo al carrello.",
      cutContext: "Il tuo testo viene ritagliato nel metallo. Scrivilo esattamente come vuoi che appaia.",
      reviewNote: "Controlla il testo e l’opzione scelta. Gli articoli personalizzati sono esclusi dai resi ordinari e dai cambi di taglia.",
      smallRing: "Anellino piccolo",
      bigRing: "Anellino grande",
      smallHeart: "Cuore piccolo",
      bigHeart: "Cuore grande",
      roundStar: "Ciondolo rotondo",
      littleStar: "Stellina",
      firstPiece: "Primo pezzo",
      secondPiece: "Secondo pezzo",
      frontArea: "Davanti",
      backArea: "Retro",
      side1: "Lato 1",
      side2: "Lato 2",

      optionalWord: 'opzionale', optPlaceholder: 'Lascia vuoto per non incidere questa zona', notEngraved: 'non inciso', extraRow: 'Incisione aggiuntiva × {n}',
      stepLabel: 'Personalizzazione', introTitle: 'Incidi il tuo gioiello',
      introP1a: 'Il tuo gioiello ha <b>{n} {units}</b> da incidere. Ogni {unit} si incide sul <b>davanti</b>',
      introP1addon: ' e, se vuoi, anche sul <b>retro</b> (+{price})', introP1end: '.',
      introP2: 'Nei prossimi passi scriverai il testo di ciascuna. Alla fine vedrai un <b>riepilogo</b> prima di aggiungere al carrello.',
      start: 'Inizia', stepOf: 'Passo {a} di {b}', yourEngraving: 'La tua incisione',
      frontLabel: 'Cosa incidiamo davanti?', placeholder: 'Scrivi il testo da incidere',
      backToggle: 'Incidi anche il retro (+{price})', backLabel: 'Cosa incidiamo dietro?',
      next: 'Avanti', review: 'Rivedi', lastStep: 'Ultimo passo', reviewTitle: 'Rivedi la tua incisione',
      frontWord: 'davanti', backWord: 'retro', total: 'Totale', totalPrefix: 'Totale: ',
      addToCart: 'Aggiungi al carrello', error: 'Impossibile aggiungere al carrello. Riprova.',
      nameFrontLabel: 'Quale nome vuoi?', namePlaceholder: 'Scrivi il nome (es. Emma)',
      nameIntroTitle: 'Il tuo nome, fatto gioiello', nameIntroP1: 'Questo gioiello è <b>tagliato al laser in un unico pezzo</b> con il nome che scegli — il nome È il gioiello.', nameIntroP2: 'Scrivilo esattamente come lo vuoi: ogni pezzo è <b>fatto a mano, uno a uno</b> — non ce ne sono due uguali. Vedrai un <b>riepilogo</b> prima di aggiungerlo al carrello.', nameStepTitle: 'Il tuo nome', nameReviewTitle: 'Controlla il nome', nameSumLabel: 'Nome',
      units: { name: { one: 'nome', many: 'nomi' }, tag: { one: 'targhetta', many: 'targhette' }, ring: { one: 'anellino', many: 'anellini' } }
    }
  };
  var T = I18N[LANG] || I18N.en;
  function tfmt(s, map) { for (var k in map) s = s.split('{' + k + '}').join(map[k]); return s; }

  var LABELS = { front: 'Tag {n} (Front)', back: 'Tag {n} (Back)' };
  var MAXLEN = 16;

  var PRODUCTS = {
    'collar-coraje-personalizado': {
      // [real] pedido EU201494 (17-jul-2026)
      labels: { front: 'Front Engraving  (a)', back: 'Back Engraving  (c)' },
      fixedUnits: 1,
      addon: { id: 53862523830615, price: 190 },
      plates: null
    },
    'collar-ventura-personalizado': {
      // [real] pedido EU201342 (13-jul-2026)
      labels: { front: 'FRONT-Engraving  (a)', back: 'BACK-Engraving  (c)' },
      fixedUnits: 1,
      addon: { id: 53862523830615, price: 190 },
      plates: null
    },
    'collar-musa-personalizado': {
      // [patron] sin pedidos; se usa el contrato mas reciente de LUMEA (coraje)
      labels: { front: 'Front Engraving  (a)', back: 'Back Engraving  (c)' },
      fixedUnits: 1,
      addon: { id: 53862523830615, price: 190 },
      plates: null
    },
    'collar-five-star-personalizable': {
      // [patron] sin pedidos; contrato mas reciente de LUMEA (coraje)
      labels: { front: 'Front Engraving  (a)', back: 'Back Engraving  (c)' },
      fixedUnits: 1,
      addon: { id: 53862523830615, price: 190 },
      plates: null
    },
    'collar-alianza-personalizado': {
      // [patron] sin pedidos; contrato mas reciente de LUMEA (coraje)
      labels: { front: 'Front Engraving  (a)', back: 'Back Engraving  (c)' },
      fixedUnits: 1,
      addon: { id: 53862523830615, price: 190 },
      plates: null
    },
    'collar-medallon-personalizado': {
      // [mismo SKU] CN539 en SOPH, pedido UK40147879
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text (single side, front)' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'collar-nombre-personalizado': {
      unitKey: 'name', uiKey: 'name', fixedUnits: 1,
      labels: { front: 'Text' },  // corte laser: el nombre ES la joya
      addon: null,
      plates: null
    },
    'collar-nombre-personalizable': {
      unitKey: 'name', uiKey: 'name', fixedUnits: 1,
      labels: { front: 'Text' },  // property del pedido = 'Text' (paridad con Textify en estas tiendas)
      addon: null,  // sin grabado trasero
      plates: null
    },
    'pulsera-uniones-personalizado': {
      unitKey: 'tag',
      addon: { id: 53862523830615, price: 190 },
      plates: {
        1: [{ x: 49, y: 86 }],
        2: [{ x: 27, y: 79 }, { x: 79, y: 75 }],
        3: [{ x: 16, y: 51 }, { x: 50, y: 85 }, { x: 87, y: 51 }]
      }
    },
    'collar-amity-personalizado': {
      unitKey: 'ring',
      labels: { front: 'Ring {n} (Front)', back: 'Ring {n} (Back)' }, // property del pedido (fulfillment, en EN como Textify)
      addon: null,  // solo grabado frontal (sin grabado detras)
      plates: null  // sin imagen/pins en el resumen para este producto
    },
    'pulsera-secreta-personalizado': {
      unitKey: 'name', fixedUnits: 1,
      // property names de Teeinblue leidos del DOM live (⚠ confirmar con un pedido antes de publicar)
      labels: { front: 'FRONT- Engraving  (a)', back: 'BACK-Engraving  (c)' },
      addon: { id: 54068426473815, price: 490 }, // suplemento dedicado creado (Grabado Detrás 4,90€)
      plates: null
    },
    // ── Migración total (21 jul 2026): contratos scrapeados de Textify, byte-exactos ──
    'collar-affection-personalizado': {
      labels: { fronts: ['Affection Small Heart', 'Affection Big Heart'] },
      unitNames: ['Affection Small Heart', 'Affection Big Heart'],
      fixedUnits: 2,
      addon: null, plates: null
    },
    'collar-apego-personalizado': {
      labels: { fronts: ['Necklace/Bracelet 1 (Small Circle)', 'Necklace/Bracelet 2 (Big Circle)'] },
      unitNames: ['Necklace/Bracelet 1 (Sma', 'Necklace/Bracelet 2 (Big'],
      fixedUnits: 2,
      addon: null, plates: null
    },
    'collar-celeste-personalizado': {
      labels: { fronts: ['Circular pendant (star)', 'Little Star (sobresaliente)'] },
      unitNames: ['Circular pendant (star)', 'Little Star (sobresalien'],
      fixedUnits: 2,
      addon: null, plates: null
    },
    'collar-infinito-personalizado': {
      labels: { fronts: ['Name 1 ', 'Name 2 ', 'Name 3', 'Name 4'] },
      addon: null, plates: null
    },
    'collar-interestelar-personalizado': {
      labels: { front: 'FRONT- Engraving  ({a})', back: 'BACK-Engraving  ({c})' },
      fixedUnits: 2,
      addon: { id: 53862523830615, price: 190 }, plates: null
    },
    'collar-nacimiento-personalizado-1': {
      labels: { front: 'Front Engraving  (a)', back: 'Back Engraving  (c)' },
      fixedUnits: 1,
      addon: { id: 53862523830615, price: 190 }, plates: null
    },
    'collar-pacto-personalizado': {
      labels: { front: 'Circle {n}-Front  ({a})', back: 'Circle {n}-BACK  ({c})' },
      addon: { id: 53862523830615, price: 190 }, plates: null
    },
    'collar-pasion-personalizado': {
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Short Text to Save' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'collar-placa-personalizado': {
      labels: { front: 'FRONT- Engraving  (a)', back: 'BACK-Engraving  (c)' },
      fixedUnits: 1,
      addon: { id: 53862523830615, price: 190 }, plates: null
    },
    'collar-promesa-personalizado': {
      labels: { fronts: [' Promise Necklace 1 (gold)', ' Promise Necklace 2 (silver)'] },
      unitNames: [' Promise Necklace 1 (gol', ' Promise Necklace 2 (sil'],
      fixedUnits: 2,
      addon: null, plates: null
    },
    'collar-puzzle-personalizado': {
      labels: { front: 'FRONT- Engraving  (a)', back: 'BACK-Engraving  (c)' },
      fixedUnits: 1,
      addon: { id: 53862523830615, price: 190 }, plates: null
    },
    'collar-recuerdos-personalizado': {
      labels: { fronts: ['Front', 'Back', 'Side 1', 'Side 2'] },
      unitNames: ['Front', 'Back', 'Side 1', 'Side 2'],
      fixedUnits: 4,
      optional: [2, 3, 4],
      extraAddon: { id: 54093438812503, price: 90, freeUnits: 1 },
      addon: null, plates: null
    },
    'collar-romantica-personalizado': {
      labels: { front: 'Front Engraving  (a)', back: 'Back Engraving  (c)' },
      fixedUnits: 1,
      addon: { id: 53862523830615, price: 190 }, plates: null
    },
    'collar-sensacion-personalizado': {
      labels: { front: 'Front Engraving  (a)', back: 'Back Engraving  (c)' },
      fixedUnits: 1,
      addon: { id: 53862523830615, price: 190 }, plates: null
    },
    'collar-sentimiento-personalizado': {
      labels: { front: 'FRONT- Engraving  ({a})', back: 'BACK-Engraving  ({c})' },
      fixedUnits: 2,
      addon: { id: 53862523830615, price: 190 }, plates: null
    },
    'collar-siempre-personalizado': {
      labels: { fronts: ['Big Heart Necklace', 'Small Heart Necklace'] },
      unitNames: ['Big Heart Necklace', 'Small Heart Necklace'],
      fixedUnits: 2,
      addon: null, plates: null
    },
    'grabado-personalizado': {
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'pulsera-alianza-personalizado': {
      labels: { front: 'Circle {n}-Front  ({a})', back: 'Circle {n}-BACK  ({c})' },
      addon: { id: 53862523830615, price: 190 }, plates: null
    },
    'pulsera-apego-personalizado': {
      labels: { fronts: ['Necklace/Bracelet 1 (Small Circle)', 'Necklace/Bracelet 2 (Big Circle)'] },
      unitNames: ['Necklace/Bracelet 1 (Sma', 'Necklace/Bracelet 2 (Big'],
      fixedUnits: 2,
      addon: null, plates: null
    },
    'pulsera-coraje-personalizado': {
      labels: { front: 'Front Engraving  (a)', back: 'Back Engraving  (c)' },
      fixedUnits: 1,
      addon: { id: 53862523830615, price: 190 }, plates: null
    },
    'pulsera-cordelia-personalizado': {
      labels: { front: 'Circle 1-Front  (a)', back: 'Circle 1-BACK  (c)' },
      fixedUnits: 1,
      addon: { id: 53862523830615, price: 190 }, plates: null
    },
    'pulsera-dua-personalizado': {
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'pulsera-hombre-lord-personalizado': {
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text (Brave Men)' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'pulsera-hombre-rebel-personalizado': {
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text (Brave Men)' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'pulsera-infinito-personalizado': {
      labels: { fronts: ['Name 1 ', 'Name 2 ', 'Name 3', 'Name 4'] },
      addon: null, plates: null
    },
    'pulsera-rosicler-personalizado': {
      uiKey: 'name', unitKey: 'name',
      labels: { front: 'Text (single side, front)' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'pulsera-de-identidad-personalizado': {
      // CB187. Placa que se graba por delante y, opcionalmente, por detras (+1,90, decision de
      // Adri 2-sep-2026). Labels en par: 'single side' se contradice con mandar una linea de
      // detras al taller. Tags con 'corte laser' Y 'grabado laser': la ficha describe una placa
      // que se GRABA, asi que va como grabado.
      labels: { front: 'Text (front)', back: 'Text (back)' },
      fixedUnits: 1,
      addon: { id: 53862523830615, price: 190 },
      plates: null
    },
    'pulsera-barra-eterna-personalizado': {
      // CB189 — EN BORRADOR en LUMEA (vivo en SOPH/MILA). [patrón] placa de una cara.
      labels: { front: 'Text (single side, front)' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'pulsera-no-me-olvides-mujer-personalizado': {
      // CB190 — EN BORRADOR en LUMEA. [patrón] barra de una cara.
      labels: { front: 'Text (single side, front)' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'pulsera-no-me-olvides-hombre-personalizado': {
      // CB191 — EN BORRADOR en LUMEA. [patrón] barra de una cara.
      labels: { front: 'Text (single side, front)' },
      fixedUnits: 1,
      addon: null, plates: null
    },
    'pulsera-sensacion-personalizable': {
      labels: { front: 'Front Engraving  (a)', back: 'Back Engraving  (c)' },
      fixedUnits: 1,
      addon: { id: 53862523830615, price: 190 }, plates: null
    }
  };

  function genGroupId() {
    return (Math.random().toString(36).slice(2, 10) + '0000000').slice(0, 8);
  }

  // {n} = nº unidad; {a}/{b}/{c} = letra correlativa del taller (u1→a/b/c, u2→d/e/f, u3→g/h/i)
  function label(tpl, n) {
    return tpl.replace('{n}', n).replace(/\{([abc])\}/g, function (_, l) {
      return String.fromCharCode(96 + (n - 1) * 3 + (l.charCodeAt(0) - 96));
    });
  }
  function unitFrontLabel(labels, i) { return labels.fronts ? labels.fronts[i] : label(labels.front, i + 1); }
  function isOptionalUnit(optional, i) { return !!optional && optional.indexOf(i + 1) > -1; }
  function filledCount(state) {
    return (state.chapitas || []).filter(function (c) { return c && c.front && c.front.trim(); }).length;
  }

  function buildCartPayload(state, opts) {
    opts = opts || {};
    var addon = opts.addon || null;
    var labels = opts.labels || LABELS;   // label de property por producto (default: Chapita)
    var optional = opts.optional || null; // unidades (1-based) que pueden ir vacías → sin property
    var extra = opts.extraAddon || null;  // {id, price, freeUnits}: addon por zona extra grabada
    var grp = opts.grp || genGroupId();
    var main = { id: state.variantId, quantity: 1, properties: {} };
    var addons = [];
    (state.chapitas || []).forEach(function (c, i) {
      var n = i + 1;
      if (isOptionalUnit(optional, i) && !(c.front && c.front.trim())) return;
      main.properties[unitFrontLabel(labels, i)] = c.front;
      if (c.backOn && addon) {
        main.properties[label(labels.back, n)] = c.back;
        addons.push({ id: addon.id, quantity: 1, properties: { _grp: grp, _chapita: String(n) } });
      }
    });
    if (extra) {
      var extras = Math.max(0, filledCount(state) - (extra.freeUnits || 1));
      for (var e = 0; e < extras; e++) addons.push({ id: extra.id, quantity: 1, properties: { _grp: grp, _zona: String(e + 2) } });
    }
    main.properties._grp = grp;
    return { items: [main].concat(addons) };
  }

  function findVariant(id, variants) {
    for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
    return null;
  }

  function validateChapita(c, opt) {
    if (!c) return false;
    var empty = !c.front || !c.front.trim();
    if (empty) return !!opt;
    if (c.backOn && (!c.back || !c.back.trim())) return false;
    return true;
  }

  function isComplete(state, opts) {
    opts = opts || {};
    var ch = (state && state.chapitas) || [];
    if (!ch.length) return false;
    var ok = ch.every(function (c, i) { return validateChapita(c, isOptionalUnit(opts.optional, i)); });
    return ok && filledCount(state) > 0;
  }

  function computeTotal(state, variants, addon, extraAddon) {
    var v = findVariant(state.variantId, variants || []);
    var base = v ? v.price : 0;
    if (addon) {
      var backs = (state.chapitas || []).filter(function (c) { return c.backOn; }).length;
      base += backs * addon.price;
    }
    if (extraAddon) base += Math.max(0, filledCount(state) - (extraAddon.freeUnits || 1)) * extraAddon.price;
    return base;
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function boot() {
    var cfgEl = document.querySelector('[data-pw-config]');
    var overlay = document.querySelector('[data-pw-overlay]');
    if (!cfgEl || !overlay) return;
    // GUARD DE ACTIVACION: el gate CSS solo oculta el boton .pw-open, pero boot() ademas
    // instala el interceptor de submit del ATC. Con el mount generico en todos los
    // personalizables, sin este guard el interceptor secuestraba el add nativo en productos
    // SIN wizard publicado y tiraba las properties de Textify (visto en LPM 18-20 jul,
    // pedidos con 'Chapita 1 (Frontal)'). Solo bootear si la activacion (PW_LIVE o
    // preview ?pw=1) puso html.pw-preview.
    if (!document.documentElement.classList.contains('pw-preview')) return;
    if (overlay.dataset.pwInit) return;
    overlay.dataset.pwInit = '1';
    // Portal: mover el overlay a <body> para que position:fixed no quede atrapado por
    // un ancestro con transform y cubra la pantalla completa (incluido el header).
    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
    var cfg = JSON.parse(cfgEl.textContent);
    var variants = cfg.variants;
    var prod = PRODUCTS[cfg.handle] || {};
    var ADDON = prod.addon || null;   // null = solo grabado frontal
    var PLATES = prod.plates || null; // null = resumen sin imagen/pins
    var UNIT = (T.units && T.units[prod.unitKey]) || T.units.tag;
    var LBL = prod.labels || LABELS;  // label de property por producto (default: Chapita)
    var ML = cfg.maxlen || prod.maxlen || MAXLEN;
    // limite POR PIEZA (metafield de lista, mismo orden que los pasos); si no hay, ML
    var MLS = (cfg.maxlens && cfg.maxlens.length) ? cfg.maxlens : (prod.maxlens || []);
    function mlFor(i) { var v = parseInt(MLS[i], 10); return v > 0 ? v : ML; }
    var OPTIONAL = prod.optional || null;
    var EXTRA = prod.extraAddon || null;
    // Display names can be complete and localised without changing the warehouse property keys.
    var DISPLAY_UNITS = {
      'collar-affection-personalizado': [T.smallHeart, T.bigHeart],
      'collar-apego-personalizado': [T.smallRing, T.bigRing],
      'pulsera-apego-personalizado': [T.smallRing, T.bigRing],
      'collar-celeste-personalizado': [T.roundStar, T.littleStar],
      'collar-promesa-personalizado': [T.firstPiece, T.secondPiece],
      'collar-recuerdos-personalizado': [T.frontArea, T.backArea, T.side1, T.side2],
      'collar-sentimiento-personalizado': [T.bigHeart, T.smallHeart]
    };
    var UNITNAMES = DISPLAY_UNITS[cfg.handle] || prod.unitNames || null;
    var GATE = prod.gate || null; // {option:'color', skip:'...'}: esa variante compra directo sin wizard
    function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }

    var state = { variantId: null, chapitas: [] };
    var step = 0; // 0..N-1 chapitas, N = review
    var submitting = false;
    var confirmedAdd = false;
    var confirmedGateAdd = false;
    var lastFocus = null;
    var savedScrollY = 0;

    var bodyEl = overlay.querySelector('[data-pw-body]');
    var titleEl = overlay.querySelector('[data-pw-title]');
    var stepEl = overlay.querySelector('[data-pw-stepnum]');
    var errEl = overlay.querySelector('[data-pw-error]');
    var backBtn = overlay.querySelector('[data-pw-back]');
    var nextBtn = overlay.querySelector('[data-pw-next]');
    var progressEl = overlay.querySelector('[data-pw-progress]');
    var badgeEl = overlay.querySelector('[data-pw-badge]');
    var priceEl = overlay.querySelector('[data-pw-price]');
    var scrollEl = overlay.querySelector('.pw-scroll');

    function currentVariant() { return findVariant(state.variantId, variants); }
    function nCh() { if (prod.fixedUnits) return prod.fixedUnits; var v = currentVariant(); return (v && v.nombres) || 1; }

    function ensureChapitas() {
      var n = nCh();
      while (state.chapitas.length < n) state.chapitas.push({ front: '', back: '', backOn: false });
      state.chapitas.length = n;
    }

    // API de test + selección real de variante
    function selectVariant(id) {
      if (submitting || gateAddBusy || confirmedAdd || confirmedGateAdd) return;
      state.variantId = Number(id); ensureChapitas(); syncAvailability();
      if (!overlay.hidden) render();
    }

    // Leer la variante seleccionada del form de producto
    function readSelectedVariantId() {
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = input ? parseInt(input.value, 10) : NaN;
      return findVariant(id, variants) ? id : (cfg.selectedVariantId || (variants[0] && variants[0].id));
    }

    function money(cents) {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
    }

    function renderProgress() {
      if (!progressEl) return;
      var total = nCh() + 1, html = '';
      for (var i = 0; i < total; i++) {
        html += '<span class="' + (i < step ? 'is-done' : (i === step ? 'is-current' : '')) + '"></span>';
      }
      progressEl.innerHTML = html;
    }

    // Total visible desde el primer paso (en el resumen ya se muestra en cuerpo y boton)
    function renderPrice() {
      if (!priceEl) return;
      var onReview = step >= nCh();
      priceEl.hidden = onReview;
      if (!onReview) {
        var label = T.totalPrefix + money(computeTotal(state, variants, ADDON, EXTRA));
        if (priceEl.textContent !== label) priceEl.textContent = label;
      }
    }

    function afterRender(focusField) {
      renderProgress();
      renderPrice();
      if (scrollEl) scrollEl.scrollTop = 0;
      bodyEl.style.animation = 'none'; void bodyEl.offsetWidth; bodyEl.style.animation = '';
      if (focusField) { var f = bodyEl.querySelector('textarea'); if (f) f.focus(); }
    }

    function render() { renderStep(); }

    function contextHTML() {
      var v = currentVariant();
      var image = v && v.image ? '<img src="' + esc(v.image) + '" alt="">' : '';
      return '<div class="pw-context">' + image + '<div><strong>' + esc(cfg.title || '') + '</strong><p>' + esc(v && (v.title || v.color) || '') + '</p><p>' + esc(cfg.kind === 'cut' ? T.cutContext : T.context) + '</p>' + (cfg.production ? '<p>' + esc(cfg.production) + '</p>' : '') + '</div></div>';
    }

    function selectionPending() {
      return Array.from(document.querySelectorAll('variant-picker[aria-busy="true"]')).some(function(picker) {
        var form = document.getElementById(picker.getAttribute('form-id'));
        var input = form && form.querySelector('[name="id"]');
        return picker.getAttribute('handle') === cfg.handle || (input && !!findVariant(Number(input.value), variants));
      });
    }

    function syncAvailability() {
      var v = currentVariant();
      var unavailable = !v || v.available === false;
      var blocked = submitting || gateAddBusy || (!(confirmedAdd || confirmedGateAdd) && (unavailable || selectionPending()));
      document.querySelectorAll('[data-pw-open]').forEach(function(button) {
        button.disabled = blocked;
        button.setAttribute('aria-disabled', String(blocked));
        if (button.classList.contains('pw-open')) {
          var label = confirmedAdd || confirmedGateAdd ? T.refreshCart : (unavailable ? T.soldOut : T.open);
          if (button.textContent !== label) button.textContent = label;
        }
      });
      if (nextBtn) updateNextEnabled();
    }

    function validUnit(i) {
      var c = state.chapitas[i];
      return validateChapita(c, isOptionalUnit(OPTIONAL, i)) && (!c.front || c.front.length <= mlFor(i)) && (!c.backOn || !c.back || c.back.length <= mlFor(i));
    }
    function completeWithinLimits() {
      return isComplete(state, { optional: OPTIONAL }) && state.chapitas.every(function(c, i) { return validUnit(i); });
    }

    function renderStep() {
      ensureChapitas();
      if (confirmedAdd) step = nCh();
      var n = nCh();
      errEl.hidden = true;
      if (step < n) {
        var c = state.chapitas[step];
        var uname = UNITNAMES && UNITNAMES[step];
        var isOpt = isOptionalUnit(OPTIONAL, step);
        stepEl.textContent = tfmt(T.stepOf, { a: step + 1, b: n + 1 });
        if (badgeEl) { badgeEl.hidden = n <= 1 && !uname; badgeEl.textContent = uname || (cap(UNIT.one) + ' ' + (step + 1)); }
        titleEl.textContent = (prod.uiKey === 'name' && T.nameStepTitle) || T.yourEngraving;
        var optHint = isOpt ? ' <span class="pw-opt">(' + T.optionalWord + (EXTRA ? ' · +' + money(EXTRA.price) : '') + ')</span>' : '';
        var ph = isOpt ? T.optPlaceholder : ((prod.uiKey === 'name' && T.namePlaceholder) || T.placeholder);
        bodyEl.innerHTML = contextHTML() +
          '<div class="pw-field"><label for="pw-front">' + ((prod.uiKey === 'name' && T.nameFrontLabel) || T.frontLabel) + optHint + '</label>' +
            '<textarea id="pw-front" aria-describedby="pw-front-limit" maxlength="' + mlFor(step) + '" rows="1" data-pw-front placeholder="' + esc(ph) + '">' + esc(c.front) + '</textarea>' +
            '<div class="pw-count" id="pw-front-limit"><span data-pw-count>' + c.front.length + '</span>/' + mlFor(step) + '</div></div>' +
          (ADDON ?
            '<label class="pw-toggle"><input type="checkbox" data-pw-backon' + (c.backOn ? ' checked' : '') + '> ' + tfmt(T.backToggle, { price: money(ADDON.price) }) + '</label>' +
            '<div class="pw-field" data-pw-backwrap' + (c.backOn ? '' : ' hidden') + '><label for="pw-back">' + T.backLabel + '</label>' +
              '<textarea id="pw-back" aria-describedby="pw-back-limit" maxlength="' + mlFor(step) + '" rows="1" data-pw-back placeholder="' + esc((prod.uiKey === 'name' && T.namePlaceholder) || T.placeholder) + '">' + esc(c.back) + '</textarea>' +
              '<div class="pw-count" id="pw-back-limit"><span data-pw-backcount>' + c.back.length + '</span>/' + mlFor(step) + '</div></div>'
          : '');
        nextBtn.textContent = (step + 1 < n) ? T.next : T.review;
      } else {
        if (badgeEl) badgeEl.hidden = true;
        stepEl.textContent = T.lastStep;
        titleEl.textContent = (prod.uiKey === 'name' && T.nameReviewTitle) || T.reviewTitle;
        var v = currentVariant();
        var maps = PLATES && PLATES[nCh()];
        var hero = '';
        if (v && v.image && maps && maps.length) {
          var pins = maps.map(function (p, i) {
            return '<span class="pw-pin" style="left:' + p.x + '%;top:' + p.y + '%">' + (i + 1) + '</span>';
          }).join('');
          hero = '<div class="pw-hero"><img src="' + esc(v.image) + '" alt="">' + pins + '</div>';
        }
        var rows = state.chapitas.map(function (c, i) {
          var rowName = (UNITNAMES && UNITNAMES[i]) || ((prod.uiKey === 'name' && T.nameSumLabel) || (cap(UNIT.one) + ' ' + (i + 1) + ' · ' + T.frontWord));
          if (isOptionalUnit(OPTIONAL, i) && !(c.front && c.front.trim())) {
            return '<div class="pw-sum"><span>' + rowName + '</span><b class="pw-sum-skip">' + T.notEngraved + '</b></div>';
          }
          return '<div class="pw-sum"><span>' + rowName + '</span><b>' + esc(c.front) + '</b></div>' +
            (c.backOn && ADDON ? '<div class="pw-sum"><span>' + cap(UNIT.one) + ' ' + (i + 1) + ' · ' + T.backWord + ' (+' + money(ADDON.price) + ')</span><b>' + esc(c.back) + '</b></div>' : '');
        }).join('');
        var extrasN = EXTRA ? Math.max(0, filledCount(state) - (EXTRA.freeUnits || 1)) : 0;
        if (extrasN) rows += '<div class="pw-sum"><span>' + tfmt(T.extraRow, { n: extrasN }) + '</span><b>+' + money(extrasN * EXTRA.price) + '</b></div>';
        bodyEl.innerHTML = contextHTML() + hero + rows + '<div class="pw-total"><span>' + T.total + '</span><span>' + money(computeTotal(state, variants, ADDON, EXTRA)) + '</span></div>';
        bodyEl.insertAdjacentHTML('beforeend', '<p class="pw-review-note">' + esc(T.reviewNote) + '</p>');
        nextBtn.textContent = T.addToCart + ' · ' + money(computeTotal(state, variants, ADDON, EXTRA));
      }
      if (confirmedAdd) { nextBtn.textContent = T.refreshCart; errEl.hidden = false; errEl.textContent = T.addedRefreshError; }
      backBtn.hidden = step === 0 || confirmedAdd;
      backBtn.disabled = submitting;
      updateNextEnabled();
      afterRender(step < n);
    }

    function updateNextEnabled() {
      var n = nCh();
      if (step < n) nextBtn.disabled = !validUnit(step);
      else nextBtn.disabled = !completeWithinLimits();
      if (confirmedAdd) nextBtn.disabled = false;
      if (submitting || (!confirmedAdd && (selectionPending() || !currentVariant() || currentVariant().available === false))) nextBtn.disabled = true;
      renderPrice();
    }

    bodyEl.addEventListener('input', function (e) {
      var c = state.chapitas[step]; if (!c) return;
      if (e.target.matches('[data-pw-front]')) { c.front = e.target.value; overlay.querySelector('[data-pw-count]').textContent = c.front.length; }
      if (e.target.matches('[data-pw-back]')) { c.back = e.target.value; overlay.querySelector('[data-pw-backcount]').textContent = c.back.length; }
      updateNextEnabled();
    });
    bodyEl.addEventListener('change', function (e) {
      if (e.target.matches('[data-pw-backon]')) {
        var c = state.chapitas[step]; c.backOn = e.target.checked;
        overlay.querySelector('[data-pw-backwrap]').hidden = !c.backOn;
        updateNextEnabled();
      }
    });

    function next() {
      if (submitting) return;
      var n = nCh();
      if (step < n) { if (!validUnit(step)) return; step++; render(); }
      else { submit(); }
    }
    function back() {
      if (submitting || step === 0) return;
      step--; render();
    }
    nextBtn.addEventListener('click', next);
    backBtn.addEventListener('click', back);


    // NOTA DE CARRITO para Outvio/almacén: resumen de grabados por SKU (lo escribía Textify
    // en LUMEA via nota; el Flow de pedido le antepone la cabecera 'Contiene Personalizable').
    // Se reconstruye desde el carrito completo -> idempotente entre adds.
    function syncCartNote(cart) {
      try {
        var lines = [];
        (cart.items || []).forEach(function (it) {
          var props = it.properties || {};
          var keys = Object.keys(props).filter(function (k) { return k && k.charAt(0) !== '_' && String(props[k] == null ? '' : props[k]).trim(); });
          if (!keys.length) return;
          lines.push((it.sku || it.product_title || '') + ':');
          keys.forEach(function (k) { lines.push(k + ': ' + props[k]); });
        });
        // _pw_note = copia de control: permite a lpm-cart-note-sync distinguir nuestra nota
        // de una escrita por el cliente, y rehacerla si luego se quita la pieza del carrito.
        var nota = lines.join('\n');
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: nota, attributes: { _pw_note: nota } })
        }).catch(function () {});
      } catch (e) {}
    }
    function validAdded(body) {
      return !!body && Array.isArray(body.items) && body.items.length > 0 && body.items.every(function(item) {
        return item && Number(item.id || item.variant_id) > 0 && Number(item.quantity) > 0;
      });
    }
    function validCart(cart) {
      return !!cart && Array.isArray(cart.items) && Number.isInteger(cart.item_count) && cart.item_count >= 0 &&
        typeof cart.total_price === 'number' && Number.isFinite(cart.total_price) && cart.total_price >= 0 &&
        cart.items.every(function(item) { return item && Number(item.id || item.variant_id) > 0 && Number(item.quantity) > 0; });
    }
    function refreshCart() {
      var root = window.Shopify && Shopify.routes && Shopify.routes.root || '/';
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function(response) { if (!response.ok) throw new Error('cart'); return response.json(); })
        .then(function(cart) {
          if (!validCart(cart)) throw new Error('cart-shape');
          syncCartNote(cart);
          document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } }));
          return cart;
        });
    }
    function addItems(payload) {
      var root = window.Shopify && Shopify.routes && Shopify.routes.root || '/';
      return fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
      }).then(function(response) { if (!response.ok) throw new Error('add'); return response.json(); })
        .then(function(body) { if (!validAdded(body)) throw new Error('add-shape'); return body; });
    }
    function submit() {
      if (submitting || (!confirmedAdd && (selectionPending() || !completeWithinLimits() || !currentVariant() || currentVariant().available === false))) return;
      submitting = true; nextBtn.disabled = true; backBtn.disabled = true;
      nextBtn.textContent = confirmedAdd ? T.refreshCart : T.adding; errEl.hidden = true;
      syncAvailability();
      // Once Shopify confirms the add, a refresh failure must only retry the read.
      var add = confirmedAdd ? Promise.resolve() : addItems(buildCartPayload(state, { addon: ADDON, labels: LBL, optional: OPTIONAL, extraAddon: EXTRA }))
        .then(function() { confirmedAdd = true; });
      add.then(refreshCart)
        .then(function() { confirmedAdd = false; submitting = false; syncAvailability(); closeModal(); })
        .catch(function() { errEl.hidden = false; errEl.textContent = confirmedAdd ? T.addedRefreshError : T.error; })
        .finally(function() {
          submitting = false;
          if (!confirmedAdd && overlay.hidden) selectVariant(readSelectedVariantId());
          syncAvailability(); backBtn.disabled = false;
          backBtn.hidden = confirmedAdd || step === 0;
          nextBtn.textContent = confirmedAdd ? T.refreshCart : T.addToCart + ' · ' + money(computeTotal(state, variants, ADDON, EXTRA));
          if (overlay.hidden && document.activeElement === document.body && lastFocus && lastFocus.isConnected && !lastFocus.disabled) lastFocus.focus();
        });
    }

    function openModal() {
      lastFocus = document.activeElement;
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.top = -savedScrollY + 'px';
      document.body.classList.add('pw-lock');
      ensureChapitas(); step = 0; overlay.hidden = false; render();
    }
    function closeModal() {
      var restoreFocus = overlay.contains(document.activeElement) || document.activeElement === document.body;
      overlay.hidden = true;
      document.body.classList.remove('pw-lock');
      document.body.style.top = '';
      window.scrollTo(0, savedScrollY);
      if (restoreFocus) {
        var target = lastFocus && lastFocus.isConnected ? lastFocus : document.querySelector('[data-pw-open]');
        if (target && !target.disabled && typeof target.focus === 'function') target.focus();
      }
    }
    overlay.querySelector('[data-pw-close]').addEventListener('click', closeModal);
    overlay.addEventListener('keydown', function(event) {
      if (event.key !== 'Tab') return;
      var elements = Array.from(overlay.querySelectorAll('button, textarea, input, a[href], [tabindex]')).filter(function(el) { return !el.disabled && el.tabIndex >= 0 && el.getClientRects().length; });
      var first = elements[0], last = elements[elements.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    // Click fuera del modal NO cierra (por peticion): solo la X o Escape.
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) closeModal(); });

    // Prestige re-renderiza la seccion del producto al cambiar de variante y vuelve a pintar
    // el markup del overlay DENTRO de la seccion → aparecen overlays duplicados (uno por cambio)
    // que se apilan al abrir el wizard (clicks confusos). Podamos: solo sobrevive el overlay
    // inicializado (movido a <body>); las copias de la seccion se eliminan.
    function pruneDuplicateOverlays() {
      var all = document.querySelectorAll('[data-pw-overlay]');
      for (var i = 0; i < all.length; i++) {
        if (all[i] !== overlay && all[i].parentNode) all[i].parentNode.removeChild(all[i]);
      }
    }

    function gateSkipped(id) {
      if (!GATE) return false;
      var v = findVariant(id != null ? id : readSelectedVariantId(), variants);
      return !!v && v[GATE.option || 'color'] === GATE.skip;
    }
    function syncGate() {
      if (!GATE) return;
      var skip = gateSkipped(null);
      document.querySelectorAll('[data-pw-open]').forEach(function (b) {
        if (!b.dataset.pwLbl) b.dataset.pwLbl = b.textContent;
        var lbl = skip ? T.addToCart.toUpperCase() : b.dataset.pwLbl;
        if (b.textContent !== lbl) b.textContent = lbl;
      });
    }
    var gateAddBusy = false;
    function gateError(message) {
      var target = document.querySelector('[data-pw-open]');
      if (!target) return;
      var error = document.querySelector('[data-pw-gate-error]');
      if (!error) { error = document.createElement('p'); error.dataset.pwGateError = ''; error.className = 'pw-error'; error.setAttribute('role', 'alert'); target.insertAdjacentElement('afterend', error); }
      error.hidden = !message; error.textContent = message || '';
    }
    function gateDirectAdd() {
      var v = findVariant(readSelectedVariantId(), variants);
      if (gateAddBusy || (!confirmedGateAdd && (selectionPending() || !v || v.available === false))) return;
      gateAddBusy = true; gateError(''); syncAvailability();
      var add = confirmedGateAdd ? Promise.resolve() : addItems({ items: [{ id: v.id, quantity: 1 }] }).then(function() { confirmedGateAdd = true; });
      add.then(refreshCart)
        .then(function() { confirmedGateAdd = false; })
        .catch(function() { gateError(confirmedGateAdd ? T.addedRefreshError : T.error); })
        .finally(function() { gateAddBusy = false; if (!confirmedGateAdd) selectVariant(readSelectedVariantId()); syncAvailability(); });
    }
    function openWizard(id) {
      if (submitting || (!(confirmedAdd || confirmedGateAdd) && selectionPending())) return;
      if (confirmedGateAdd) { gateDirectAdd(); return; }
      selectVariant(id != null ? id : readSelectedVariantId());
      if (!confirmedAdd && !confirmedGateAdd && (!currentVariant() || currentVariant().available === false)) return;
      if (gateSkipped(state.variantId)) { gateDirectAdd(); return; }
      pruneDuplicateOverlays(); openModal();
    }

    // CTA que sustituye al ATC nativo (type=button, no envia el form): solo abre el wizard.
    // DELEGADO en document: Prestige re-renderiza la seccion del producto al cambiar de
    // variante y reemplaza el boton; con binding directo el boton nuevo quedaba muerto.
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-pw-open]') : null;
      if (t) { e.preventDefault(); openWizard(); }
    });

    // Red de seguridad: interceptar el submit del form de producto SOLO si la variante
    // enviada pertenece a este producto (por id). En captura + stopImmediatePropagation
    // para ganar al handler de Prestige. No afecta a productos relacionados (otras variantes).
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      var idInput = form.querySelector('[name="id"]');
      var id = idInput ? parseInt(idInput.value, 10) : NaN;
      if (!findVariant(id, variants)) return; // no es nuestro producto -> dejar add normal
      if (gateSkipped(id)) { e.preventDefault(); e.stopImmediatePropagation(); gateDirectAdd(); return; }
      e.preventDefault();
      e.stopImmediatePropagation();
      openWizard(id);
    }, true);

    // Listener para re-sincronizar cuando cambia la variante seleccionada en el form
    document.addEventListener('change', function (e) {
      if (e.target.matches('form[action*="/cart/add"] [name="id"]')) { pruneDuplicateOverlays(); selectVariant(readSelectedVariantId()); syncGate(); }
    });
    selectVariant(readSelectedVariantId());
    document.addEventListener('variant:change', function(event) {
      var variant = event.detail && event.detail.variant;
      if (variant && findVariant(Number(variant.id), variants)) selectVariant(variant.id);
    });
    new MutationObserver(function() { syncAvailability(); }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-busy'] });
    syncGate();
    if (GATE) new MutationObserver(function () { syncGate(); }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.PersoWizard = {
    PRODUCTS: PRODUCTS, LABELS: LABELS, MAXLEN: MAXLEN,
    genGroupId: genGroupId, buildCartPayload: buildCartPayload,
    computeTotal: computeTotal, validateChapita: validateChapita, isComplete: isComplete, findVariant: findVariant
  };
})();
